/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((_theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    okButton: {
        minWidth: '66px',
    },
}));
const WarningModal = ({
    visibility,
    title,
    message,
    content,
    confirmButtonText,
    confirmButtonStyle,
    onConfirmation,
    cancelButtonText,
    cancelButtonStyle,
    onCancel,
    extraContent,
    enableClickOutside = true,
}) => {
    const classes = useStyles();
    return (
        <Dialog
            open={visibility}
            onClose={enableClickOutside && onCancel}
            aria-labelledby="confirm-status-update-dialog"
            className={classes.dialogOverride}>
            {title && <DialogTitle id="form-dialog-title">{title}</DialogTitle>}
            {message && (
                <DialogContent>
                    <DialogContentText>{message}</DialogContentText>
                    {extraContent && <div>{extraContent}</div>}
                </DialogContent>
            )}
            {content && <DialogContent>{content}</DialogContent>}
            <DialogActions>
                {cancelButtonText && (
                    <Button variant={cancelButtonStyle || 'outlined'} onClick={onCancel}>
                        {cancelButtonText}
                    </Button>
                )}
                {confirmButtonText && (
                    <Button className={classes.okButton} variant={confirmButtonStyle || 'contained'} onClick={onConfirmation}>
                        {confirmButtonText}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default WarningModal;
